// The navy page header (Discover V2's .dv2-hero): what the AI reviewer
// does, and the campaign's verdict counts. "Checking now" appears only while
// a run is going, from the videos' live status.
import React from 'react';
import Box from '@mui/material/Box';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { HowItWorks } from './aiUi';
import { C } from './ui';

const HERO_STATS = [
    { key: 'total', label: 'VIDEOS', dot: 'rgba(255,255,255,0.5)' },
    { key: 'PASS', label: 'PASSED', dot: '#4ade80' },
    { key: 'FAIL', label: 'FAILED', dot: '#f87171' },
    { key: 'NEEDS-REVIEW', label: 'NEED REVIEW', dot: '#fbbf24' },
];

function Live({ count }) {
    return (
        <div role="status" style={{ display: 'inline-flex', alignItems: 'center', gap: 8, alignSelf: 'flex-end', padding: '5px 11px', borderRadius: 999, background: 'rgba(254,189,28,0.14)', border: '1px solid rgba(254,189,28,0.4)', color: '#fff', fontSize: 12, fontWeight: 600 }}>
            <span className="vqc-pulse" style={{ width: 8, height: 8, borderRadius: 8, background: C.gold }} />
            {count} checking now
        </div>
    );
}

export default function QcHero({ stats }) {
    return (
        <Box className="dv2-hero" sx={{ mb: 1.5, py: '18px !important', px: '22px !important' }}>
            <Box sx={{ position: 'relative', zIndex: 1 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 2 }}>
                    <Box sx={{ flex: '1 1 420px', minWidth: 0 }}>
                        <p className="dv2-hero-kicker" style={{ textAlign: 'left', display: 'flex', alignItems: 'center', gap: 6, fontSize: 12 }}>
                            <AutoAwesomeIcon aria-hidden="true" style={{ fontSize: 14 }} />AI video QC
                        </p>
                        <h1 className="dv2-hero-title" style={{ textAlign: 'left' }}>Check creator videos against the brief</h1>
                        <p className="dv2-hero-sub" style={{ textAlign: 'left', maxWidth: 560 }}>
                            An AI reviewer watches each video and checks every requirement in the brief. It returns Pass, Fail or Needs review, with evidence and timestamps.
                        </p>
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        {stats?.running > 0 && <Live count={stats.running} />}
                        <Box sx={{ display: 'flex', gap: 1.25, flexWrap: 'wrap' }}>
                            {HERO_STATS.map((s) => (
                                <Box key={s.key} className="dv2-stat">
                                    <div className="dv2-stat-num">{stats ? stats[s.key] : '—'}</div>
                                    <div className="dv2-stat-label" style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 12, color: 'rgba(255,255,255,0.72)' }}>
                                        <span aria-hidden="true" style={{ width: 6, height: 6, borderRadius: 6, background: s.dot, flexShrink: 0 }} />
                                        {s.label}
                                    </div>
                                </Box>
                            ))}
                        </Box>
                    </Box>
                </Box>
                <HowItWorks dark style={{ marginTop: 14 }} />
            </Box>
        </Box>
    );
}
